<div class="row">
    <div class="col-md-12">

        <!-- Inline update komponenta za opasne materije -->
        <yt-eprijemnica-opasna-materija-inline-update
            #baseInlineUpdate>
        </yt-eprijemnica-opasna-materija-inline-update>

    </div>
</div>

<div class="row">
    <div class="col-lg-12">

        <!-- Lista stavki opasnih materija -->
        <yt-fw-default-detail-list-inline
            #baseDetailList
            [Model]="modelData.MainList.DetailList[2]"
            [ParentPropertyName]="_parentPropertyName"
            [ParentPropertyValue]="_parentPropertyValue"
            [Disabled]="!_parentPropertyValue || _parentPropertyValue <= 0">
        </yt-fw-default-detail-list-inline>

    </div>
</div>
